// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__20AVT","gfeWrapper":"CalendarEvent_gfeWrapper__2LM82"};